import './landing_page.css'
import React, { useState, useEffect } from 'react';
import Navbar from '../../components/navigations/Navbar';
import LpHeroSection from './sections/LpHeroSection';
import LpAboutSection from './sections/LpAboutSection';
import LpFeaturesSection from './sections/LpFeatureSection';
import LpHowItWorksSection from './sections/LpHowItWorkSection';
import LpStatsSection from './sections/LpStatsSection';
import LpTestimonialsSection from './sections/LpTestimonialSection';
import LpPricingSection from './sections/LpPricingSection';
import LpCTASection from './sections/LpCTASection';
import Footer from '../../components/Footer';

export const LandingPage = () => {
  const [accessToken, setAccessToken] = useState('')

  useEffect(() => {
    const token = localStorage.getItem('token-radiustrend')
    if (token) {
      setAccessToken(token)
    }
  },[])

  return (
    <>
        <Navbar accessToken={accessToken} />
        <main className='text-xs md:text-sm'>
          <LpHeroSection accessToken={accessToken} />
          <div className="section-line" aria-hidden="true" />
          <LpStatsSection />
          <div className="section-line" aria-hidden="true" />
          <LpAboutSection />
          <div className="section-line" aria-hidden="true" />
          <LpFeaturesSection />
          <div className="section-line" aria-hidden="true" />
          <LpHowItWorksSection />
          <LpPricingSection />
          <div className="section-line" aria-hidden="true" />
          <LpTestimonialsSection />
          <div className="section-line" aria-hidden="true" />
          <LpCTASection />
        </main>
        <Footer />
    </>
  )
}